"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function getEntornFormUrl() {
  var url = document.location;

  if (url.hostname.toLowerCase().includes('localhost')) {
    return 'Desenvolupament';
  }

  if (url.hostname.toLowerCase().startsWith('pre-') || url.hostname.toLowerCase().startsWith('des.')) {
    return 'Preproducció';
  }

  return 'Producció';
}

exports.getEntornFormUrl = getEntornFormUrl;